import { createFileRoute } from '@tanstack/react-router'
import { FeatureLanding } from './-components/feature-landing'
import { buildSeo } from './-lib/seo'
import { createSiteTranslate } from './-lib/site-i18n'

export const Route = createFileRoute('/(public)/scanner')({
	ssr: true,
	head: ({ match }) => {
		const { appLanguage } = match.context
		const t = createSiteTranslate(appLanguage)
		return buildSeo({
			appLanguage,
			path: '/scanner',
			title: t('site:seo.scanner.title'),
			description: t('site:seo.scanner.description')
		})
	},
	component: ScannerPage
})

function ScannerPage() {
	const { appLanguage } = Route.useRouteContext()
	const t = createSiteTranslate(appLanguage)

	return (
		<FeatureLanding
			ctaSubtitle={t('site:landing.download.subtitle')}
			ctaTitle={t('site:scanner.cta.title')}
			eyebrow={t('site:scanner.hero.eyebrow')}
			features={[
				{
					body: t('site:scanner.f1.body'),
					title: t('site:scanner.f1.title')
				},
				{
					body: t('site:scanner.f2.body'),
					title: t('site:scanner.f2.title')
				},
				{
					body: t('site:scanner.f3.body'),
					title: t('site:scanner.f3.title')
				}
			]}
			lead={t('site:scanner.hero.lead')}
			t={t}
			title={t('site:scanner.hero.title')}
		/>
	)
}
